<div class="ticket-transfer-confirm-modal">
  <div class="ticket-transfer-confirm-modal-header">
    <h5>{{ 'fgbcl.ticket.transfer.confirm.modal.title' | translate }}</h5>
  </div>
  <div class="ticket-transfer-confirm-modal-body">
    <p [innerHtml]="'fgbcl.ticket.transfer.confirm.modal.prompt' | translate: { emailAddress: emailAddress }"></p>
    <fgbcl-selected-tickets-table></fgbcl-selected-tickets-table>
  </div>
  <div class="action-wrapper">
    <button class="btn text-danger" (click)="close()">
      {{ 'fgbcl.ticket.transfer.confirm.modal.cancel.button' | translate }}
    </button>
    <button class="btn btn-success" (click)="confirm()">
      {{ 'fgbcl.ticket.transfer.confirm.modal.confirm.button' | translate }}
    </button>
  </div>
</div>
